import DashboardPerfil from '@/views/perfil/DashboardPerfil';
import CadastroPerfil from '@/views/perfil/CadastroPerfil';

const PerfilRoutes = [
  {
    path: '/perfil',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Perfil' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardPerfil',
    component: DashboardPerfil,
  },
  {
    path: '/perfil/cadastrar',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Perfil', href: '/perfil' },
        { position: 3, text: 'Cadastro do Perfil' },
      ],
      requiresAuth: true,
    },
    name: 'CadastroPerfil',
    component: CadastroPerfil,
  },
];

export default PerfilRoutes;
